import { render, staticRenderFns } from "./SignCreditAuth.vue?vue&type=template&id=20f54759"
import script from "./SignCreditAuth.vue?vue&type=script&lang=js"
export * from "./SignCreditAuth.vue?vue&type=script&lang=js"
import style0 from "./SignCreditAuth.vue?vue&type=style&index=0&id=20f54759&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports